import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from 'mobx';
import ErrorBoundry from "../ErrorBoundry/ErrorBoundry";
import getCropUrl from "../../utils/getCropUrl"
import isRetina from "is-retina"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

@inject("store")
@observer

export default class OrderLineQuantity extends React.Component {
    constructor(props) {
        super(props);

        this.updateQuantity = this.updateQuantity.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.state = { min: 0, max: 10, currentQuantity: 1 };
    }

    componentDidMount() {
        this.setState({ currentQuantity: this.props.orderLine.Quantity });
    }

    updateQuantity(e) {
        const newQuantity = e.target.value;
        this.setState({ currentQuantity: newQuantity });
        e.preventDefault();
        const changes = [
            {
                Sku: this.props.orderLine.Sku,
                VariantSku: this.props.orderLine.VariantSku,
                OriginalQuantity: newQuantity,
                //AddQuantity: newQuantity - this.props.orderLine.Quantity,
                ProductUrl: ""
            }
        ];
        var that = this;

        const result = this.props.store.order.updateQuantities(changes).then(function(res) {
            if (that.props.callback) {
                that.props.callback(res);
            }
        });
    }

    renderOptions() {
        let options = [];
        for (let i = this.state.min; i <= this.state.max; i++) {
            options.push(<option key={"quantity_option_" + i} value={i}>{i}</option>);
        }

        return options;
    }

    UNSAFE_componentWillReceiveProps(next, current) {
        //console.log("willReceiveProps", next, current);

        if (next.orderLine.Quantity !== this.state.currentQuantity) {
            this.setState({ currentQuantity: next.orderLine.Quantity });
        }
    }

    render() {
        const orderLine = this.props.orderLine;
        return (
            <div className="quantity-container-inner">
                <span className="orderline-quantity-text">{this.props.store.navigation.dictionary.Quantity}</span>
                <div className="orderline-quantity-select-container">
                    <div className="orderline-quantity-select-arrow"></div>
                    <select className="orderline-quantity-select" onChange={this.updateQuantity} value={this.state.currentQuantity}>
                        {this.renderOptions()}
                    </select>
                </div>

            </div>
        );
    }
}